<form [formGroup]="form">
    <table class="properties-table">
        @for (property of controls; track property.name) {
            <tr>
                <td>
                    <div>
                        @if (property.needsConfirmation) {
                            <i class="fas fa-exclamation-triangle" [ngbTooltip]="'properties.needsConfirmation' | translation | async" placement="right"></i>
                        }
                    </div>
                </td>

                <td>
                    <div>
                        @switch (property.controlType) {
                            @case (controlTypes.Toggle) {
                                <div>
                                    @if (!isCommand) {
                                        <app-standard-toggle-switch
                                            [label]="property.caption"
                                            [toggledLabel]="'defaults.yes' | translation | async"
                                            [toggledTooltip]="'properties.commandToggledTooltip' | translation | async"
                                            [notToggledLabel]="'defaults.no' | translation | async"
                                            [notToggledTooltip]="'properties.commandNotToggledTooltip' | translation | async"
                                            [formControlName]="property.name"
                                            (toggleChanged)="checkForChange(property.name)"
                                        ></app-standard-toggle-switch>
                                    }
                                    @if (isCommand) {
                                        <app-standard-toggle-switch-tristate
                                            [label]="property.caption"
                                            [toggledLabel]="'defaults.yes' | translation | async"
                                            [notToggledLabel]="'defaults.no' | translation | async"
                                            [neutralToggledLabel]="'defaults.keep' | translation | async"
                                            [formControlName]="property.name"
                                            (toggleChanged)="checkForChange(property.name)"
                                        ></app-standard-toggle-switch-tristate>
                                    }
                                </div>
                            }

                            @case (controlTypes.Slider) {
                                <div>
                                    @if (!property.disabled) {
                                        <app-standard-slider
                                            [label]="property.caption"
                                            [maxValue]="property.maxValue"
                                            [minValue]="property.minValue"
                                            [step]="property.displayFormat"
                                            [unit]="property.unit"
                                            [formControlName]="property.name"
                                            (sliderChanged)="checkForChange(property.name)"
                                        ></app-standard-slider>
                                    }

                                    @if (property.disabled) {
                                        <app-standard-textbox
                                            [label]="property.caption"
                                            [formControlName]="property.name"
                                            [maxlength]="property.maxLength"
                                            [addOnText]="property.unit"
                                            (input)="checkForChange(property.name)"
                                        ></app-standard-textbox>
                                    }
                                </div>
                            }

                            @case (controlTypes.TextBox) {
                                <div>
                                    <app-standard-textbox
                                        [label]="property.caption"
                                        [formControlName]="property.name"
                                        [maxlength]="property.maxLength"
                                        [addOnText]="property.unit"
                                        (input)="checkForChange(property.name)"
                                    ></app-standard-textbox>
                                </div>
                            }

                            @case (controlTypes.DropDown) {
                                <div class="properties-dropdown-list">
                                    <ng-select
                                        [loadingText]="'defaults.loading' | translation | async"
                                        [notFoundText]="'defaults.noItemsFound' | translation | async"
                                        [formControlName]="property.name"
                                        [searchable]="false"
                                        labelForId="{{ property.name }}"
                                        [items]="property.dropDownItems"
                                        bindValue="value"
                                        bindLabel="displayName"
                                        (change)="checkForChange(property.name)"
                                        [placeholder]="property.caption"
                                        aria-describedby="descriptionBlock"
                                    >
                                        <ng-template ng-option-tmp let-item="item">
                                            <div [ngbTooltip]="item.displayName" placement="auto" [openDelay]="1000" class="text-truncate">{{ item.displayName }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            }
                        }
                    </div>

                    <app-property-information [property]="property"></app-property-information>
                </td>
                <td>
                    <div>
                        @if (changeMarkerActive && form.controls[property.name].dirty) {
                            <li class="fas fa-pencil-alt default-icon-color"></li>
                        }
                    </div>
                </td>
            </tr>
        }
    </table>
</form>
